const actionItemStatusType = (statusNumber) => {
  if (statusNumber === 0) return "Assigned";
  if (statusNumber === 1) return "Submitted";
  if (statusNumber === 2) return "Incomplete";
  if (statusNumber === 3) return "Accepted";
};

const actionItemTypes = (typeNumber) => {
  if (typeNumber === 0) return "Administrative";
  if (typeNumber === 1) return "Corrective";
  if (typeNumber === 2) return "Certification";
};

export { actionItemStatusType, actionItemTypes };
